"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectsCreateRequestApplyTextNormalization = void 0;
exports.ProjectsCreateRequestApplyTextNormalization = {
    Auto: "auto",
    On: "on",
    Off: "off",
    ApplyEnglish: "apply_english",
};
